import { Injectable } from '@angular/core';

import { BaseHttpClientService } from '../../base-http-client.service';
import { GetExamDetailResponseModel } from 'src/app/shared/api-models/responses/exam/GetExamDetailResponseModel';
import { GetTestsResponseModel } from 'src/app/shared/api-models/responses/test/GetTestsResponseModel';

/**
 * گرفتن لیست مقاطع تحصیلی
 */
@Injectable({
  providedIn: 'root'
})
export class GetVideoReportService {
  constructor(private baseClient: BaseHttpClientService) { }

  call() {
    const res = this.baseClient.getWithAuth<GetTestsResponseModel>(
      `/api/v1/VideoErrorReport`
    );

    return res;
  }
}
